import React, { useEffect, useState } from "react";
import GridItem from "../../views/Grid/GridItem.js";
import GridContainer from "../../views/Grid/GridContainer.js";
import Card from "../../views/Card/Card.js";
import CardHeader from "../../views/Card/CardHeader.js";
import CardBody from "../../views/Card/CardBody.js";
import Table from "../../views/Table/Table.js";
import IconButton from "@material-ui/core/IconButton";
import EditRoundedIcon from "@material-ui/icons/EditRounded";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Pagination } from "@material-ui/lab";
import { Tooltip } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import CryptoJS from "crypto-js";
import moment from "moment";


import style from "./styles.module.css";
import Snackbar from "../utils/snackbar/Snackbar";
import VerifyModal from "./Modal/VerifyModal.js";
import { getData } from "../../restfulservices/httpHandler.js";

const VerifyUser = (props) => {
  const [filteredData, setFilteredData] = useState([]);
  const [supportCount, setSupportCount] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [activeUser, setActiveUser] = useState(null);

  const limit = 5;

  useEffect(() => {
    fetchCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const fetchCategory = async () => {
    setLoading(true);
    try {
      const res = await getData(`v1/user/requestVerifiedUsers?page=${page}&limit=${limit}`);
      const decryptionKey = process.env.REACT_APP_SECRET_KEY;

      // Decrypt emails
      const decryptedData = res.data.data.data.map(user => {
        const decryptedEmail = CryptoJS.AES.decrypt(user.email, decryptionKey).toString(CryptoJS.enc.Utf8);
        return { ...user, email: decryptedEmail };
      });

      setFilteredData(decryptedData);
      setSupportCount(res.data.data.count);
    } catch (error) {
      console.error("Error fetching users:", error);
      setFilteredData([]);
      setSupportCount(0);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (date) => moment(date).format("MMM Do YY");

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const details = filteredData.map((val, index) => ([
    index + 1,
    val.name,
    val.email,
    val.profileType,
    val.role,
    val.isVerified ? "Yes" : "No",
    formatDate(val.createdAt),
    <React.Fragment key={val.id}>
      <Tooltip title="Edit">
        <IconButton
          onClick={() => {
            setActiveUser(val);
            setEditModal(true);
          }}
        >
          <EditRoundedIcon />
        </IconButton>
      </Tooltip>
    </React.Fragment>,
  ]));

  return (
    <GridContainer>
      {activeUser && (
        <VerifyModal
          type="EDIT"
          userData={activeUser}
          open={editModal}
          onClose={() => setEditModal(false)}
          onDone={() => {
            setEditModal(false);
            setActiveUser(null);
            fetchCategory();
          }}
          setAlert={(msg) => setAlert(msg)}
        />
      )}
      <Snackbar open={alert} handleClose={() => setAlert(false)} />

      <GridItem xs={12} sm={12} md={12}>
        <Card>
          <CardHeader color="primary">
            <div className={style.cardHeader}>
              <h4>Verification Requests</h4>
            </div>
          </CardHeader>
          <CardBody>
            {loading ? (
              <div className={style.loader}>
                <CircularProgress />
              </div>
            ) : filteredData.length === 0 ? (
              <div style={{ textAlign: "center", padding: "20px" }}>No verification requests found.</div>
            ) : (
              <Table
                tableHeaderColor="primary"
                tableHead={[
                  "S.N", "Name", "Email", "Profile Type", "Role", "Verified", "Verification Date", "Actions"
                ]}
                tableData={details}
              />
            )}
          </CardBody>
        </Card>
      </GridItem>

      {supportCount > limit && (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px" }}>
          <Pagination
            count={Math.ceil(supportCount / limit)}
            page={page}
            onChange={handleChangePage}
          />
        </div>
      )}
    </GridContainer>
  );
};

const mapStateToProps = (state) => ({
  user: state.appReducer.user,
});

export default withRouter(connect(mapStateToProps)(VerifyUser));
